import React, { useEffect, useState } from "react";
import "./etapes.css";
import { BiArrowToTop } from "react-icons/bi";


const ScrollToTop = () => {
    const [isVisible, setIsVisible] = useState(false);

    const showVisiblity = () => {
      if (window.pageYOffset>200) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    const ScrollToTop =()=>{
        window.scrollTo({
            top:0,
            behavior:'smooth',
        });
    };

    useEffect(()=>{
        window.addEventListener('scroll',showVisiblity);
        return()=>{
          window.removeEventListener('scroll',showVisiblity);
        }
    },[]);

    return (
      <div className="scroll-to-top" >
        <button onClick={ScrollToTop} > <BiArrowToTop className="icon h-6 w-6"/> </button>
      </div>
    )
  };

export default ScrollToTop;
